import { EditIcon } from '@sketchnote/icons';
import React from 'react';
import { useAuth } from 'src/shared/hooks/use-auth';

export interface TemplateCardProps {
  title: string;
  description: string;
  onClick?: any;
  onDelete?: any;
  onEdit?: any;
  image: {
    url: any;
    alt: any;
  };
  tag?: string;
  color: string;
}

export const TemplateCard = ({
  title,
  description,
  onClick,
  tag,
  image,
  color,
  onDelete,
  onEdit,
}: TemplateCardProps) => {
  const [isActive, setActive] = React.useState<boolean>(false);
  const authData = useAuth((s) => s.userDetails);

  const isSketchnoteMember =
    authData?.email.endsWith('sketchnote.co') ||
    authData?.email === 'placebonikhil@gmail.com' ||
    authData?.email === 'aayushlama26@gmail.com' ||
    authData?.email === 'swp.desai@gmail.com';

  const Color = React.useMemo(
    () => ({
      blue: {
        tag: '#211650',
        bg: '#EEF1FC',
      },
      green: {
        tag: '#15B9B0',
        bg: '#DFF8E3',
      },
      pink: {
        tag: '#EC7DD5',
        bg: '#FEDEE6',
      },
    }),
    []
  );

  return (
    <div
      style={{
        width: '234px',
        height: '239px',
        border: '1px solid #E2E4E9',
        borderRadius: '6px',
        minWidth: '243px',
      }}
      className="flex flex-col border-gray-200 border-solid relative "
      onMouseOver={() => setActive(true)}
      onMouseLeave={() => setActive(false)}
    >
      <div
        style={{
          width: 'fit-content',
          backgroundColor: `${Color[color].bg}`,
          filter: `${isActive ? 'blur(4px)' : 'none'}`,
        }}
        className="m-0 h-144  px-20 pt-15 relative overflow-hidden"
      >
        <div
          style={{ background: `${Color[color].tag}` }}
          className="py-4 px-6 inline-block rounded-sm"
        >
          <p className="text-xs text-white font-semibold">{tag}</p>
        </div>
        <img
          style={{ borderRadius: '4px' }}
          className="mt-8  object-cover w-full h-full"
          src={
            image.url
              ? image.url
              : 'https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__480.jpg'
          }
          alt={image.alt}
        />
        {/* <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(50%,-50%)',
          }}
        >
         
        </div> */}
      </div>
      <button
        onClick={onClick}
        className={`absolute bg-blue-500 text-sm font-bold py-6 px-16 rounded-sm text-white top-60 left-55 transform ${
          isActive ? 'opacity-1' : 'opacity-0'
        } transition-all duration-75 ease-in-out`}
      >
        Add template
      </button>
      {isSketchnoteMember && (
        <>
          <button
            onClick={onDelete}
            className={`absolute bg-red-500 text-sm font-bold py-6 px-16 rounded-sm text-white top-0 right-0 transform ${
              isActive ? 'opacity-1' : 'opacity-0'
            } transition-all duration-75 ease-in-out`}
          >
            X
          </button>
          <div
            onClick={onEdit}
            className={`absolute flex justify-center items-center bg-white cursor-pointer  py-6 px-16 h-52 rounded-md shadow-md text-white bottom-2 right-0 transform translate-y-3 gap-2 ${
              isActive ? 'opacity-1' : 'opacity-0'
            } transition-all duration-75 ease-in-out`}
          >
            <EditIcon fill="#878A92" />
            <p className="text-sm font-regular text-gray-999">Edit Template</p>
          </div>
        </>
      )}
      <div className="p-16 flex flex-col flex-auto justify-center bg-white">
        <h4 className="text-base font-semibold text-gray-999 leading-20">{title}</h4>
        <p
          className="font-normal text-sm text-gray-600 leading-20"
          style={{
            wordWrap: 'break-word',
            overflow: 'ellipsis',
            display: '-webkit-box',
            overflowY: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {description.length > 55 ? description.slice(0, 55) + '...' : description.length}
        </p>
      </div>
    </div>
  );
};
